import React, { Component, Fragment, useEffect, useRef, useState } from 'react';
import TabMenu, { TabMenu2 } from '../components/TabMenu';
import DataCenter, { Calculator, QuoteCoinID, CurrentCurrency } from '../modules/DataCenter';
import { Events, JSEvent } from "../utils/JSEvent";
import { WalletTypes, CoinType, WalletAccount, WAIdToString, WAIdToName } from '../conf/Config';
import Button from '../components/control/Button';
import { BalanceLabel, CoinPanel, CoinSelector, InformationBar, LoadingDialog, SuccessfulDialog, TotalBalanceViewWithDefi } from '../components/CommonComponents';
import { useSpring, animated } from '@react-spring/web';
import useMeasure from 'react-use-measure';
import iconExchange from '../images/icon-exchange.svg'
import BigNumber from 'bignumber.js';
import { request } from '../utils/request';
import API from '../conf/API';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, SelectorIcon, ArrowLeftIcon, ArrowNarrowLeftIcon, ArrowNarrowDownIcon, ArrowsExpandIcon, ArrowCircleUpIcon, ArrowSmLeftIcon, ArrowUpIcon, ArrowDownIcon, ArrowNarrowUpIcon, ChevronRightIcon } from '@heroicons/react/solid'
import { WalletService } from '../modules/WalletService';
import { ToastType, useToast } from '../components/Toast';
import BaseView from '../components/BaseViewComponent';
import { WithdrawView } from './WithdrawView';
import { LoadingSVG } from '../components/Svgs';
import { TopupView } from './TopupView';
import { Localize } from '../modules/localize/Localize';
import { TransferView } from './TransferView';

export default class FundView extends BaseView {
    constructor(props) {
        super(props);
        this.initState({
            dataReady: { wallet: false, symbol: false, thumb: false },
            currTabItem: null,
            move: 0,
            showLoading: false,
            showSuccess: false,
        })
        this.onDataReady = this.onDataReady.bind(this);
        this.controller = this.props.controller;
    }

    componentDidMount() {
        super.componentDidMount?.();
        JSEvent.on(Events.DataCenter.DATA_UPDATED, this.onDataReady);
        this.controller.init();
    }

    componentWillUnmount() {
        super.componentWillUnmount?.();
        JSEvent.remove(Events.DataCenter.DATA_UPDATED, this.onDataReady)
        this.controller.destroy();
    }

    onDataReady(dataName) {
        // if (dataName == "wallet") {
        //     this.setState({ walletReady: true });
        // } else if (dataName == "symbol") {
        //     this.setState({ symbolReady: true });
        // }

        this.state.dataReady[dataName] = true;

        let allReady = true;
        for (const dn in this.state.dataReady) {
            const dr = this.state.dataReady[dn];
            if (dr == false) {
                allReady = false;
                break;
            }
        }
        if (allReady) {
            this.forceUpdate();
        }
    }

    onTabItemChanged(type, item) {
        this.setState({ currTabItem: item })
    }

    /* <div className=' transition ease-in-out hover:translate-x-20 bg-gray-400 w-24 h-24'></div> */

    render() {
        let wa = this.state.currTabItem == null ? WalletAccount.All : this.state.currTabItem.walletId;
        const totalBalance = Calculator.calcTotalBalance(wa);
        let quoteCoin = DataCenter.getCoin(QuoteCoinID);

        let coinPanels = [];

        if (DataCenter.hasSymbolData()) {
            const coins = DataCenter.getCoins();
            const l = coins.length;
            for (let i = 0; i < l; i++) {
                const coin = coins[i];
                coinPanels.push(<CoinPanel coin={coin} key={coin.id} wallet={wa} hideFrozen={wa == WalletAccount.GameAccount} />);
                if (i < l - 1)
                    coinPanels.push(<div className='w-full h-[1px] bg-gray-100' key={coin.id + 100000000} />)
            }
        }

        return (
            <div className='bg-gray-100 flex-row flex-1 flex'>
                <WalletPanel
                    currAccount={wa}
                    totalBalance={totalBalance}
                    quoteCoin={quoteCoin}
                    coinPanels={coinPanels}
                    move={this.state.move}
                    onTabItemChanged={(type, item) => this.onTabItemChanged(type, item)}
                    onButtonClicked={btn => {
                        if (btn == "Transfer") {
                            //this.setState({ move: -1 })
                            this.addView(TransferView, "left", null, action => { }, {
                                addView: this.addView,
                                currentAccount: this.state.currTabItem
                            });
                        } else if (btn == "Withdraw") {
                            this.addView(WithdrawView, "left", null, action => { }, {
                                addView: this.addView,
                                walletAccount: wa
                            });
                        } else if (btn == "topup") {
                            this.addView(TopupView, "left", null, action => { }, {
                                addView: this.addView,
                                walletAccount: wa
                            });
                        }
                    }} />

                {/* <TransferPanelWrapper move={this.state.move} currentAccount={this.state.currTabItem}
                    onBackButtonClicked={
                        btn => {
                            this.setState({ move: 1 })
                        }
                    }
                    onTransfer={state => {
                        if (state == "start") {
                            this.setState({ showLoading: true })
                        } else {
                            this.setState({ move: 1, showLoading: false });
                        }
                    }}
                /> */}

                {this.state.views}

                <LoadingDialog
                    show={this.state.showLoading}
                />

                <SuccessfulDialog show={this.state.showSuccess} text="转账成功" />
            </div>
        )
    }
}

const TransferPanelWrapper = ({ move, currentAccount, onBackButtonClicked, onTransfer }) => {
    const [makeToast] = useToast();
    return <TransferPanel
        move={move}
        currentAccount={currentAccount}
        onBackButtonClicked={onBackButtonClicked}

        onTransferButtonClicked={
            params => {
                onTransfer("start")
                const url = API.wallet_transfer(params);
                request(url).then(ret => {
                    DataCenter.updateWalletBalance(ret);
                    onTransfer("end")
                    makeToast("划转成功", ToastType.right);
                })
            }
        }
    />
}

function WalletPanel_DeFiPanel() {

    const [totalBalance, setTotalBalance] = useState("--");


    const onDataUpdate = (dataName) => {
        if (dataName == "quotePrice" || dataName == "wallet") {
            updateTotalBalance();
        }
    }

    const onBalanceUpdate = ({ token, balance }) => {
        updateTotalBalance();
    }


    const updateTotalBalance = () => {
        const walletInfo = WalletService.walletInfo;
        if (walletInfo == null) {
            setTotalBalance("--");
        } else {
            setTotalBalance(walletInfo.totalBalance())
        }
    }

    useEffect(() => {
        JSEvent.on(Events.DataCenter.DATA_UPDATED, onDataUpdate);
        JSEvent.on(Events.Wallet.BalanceUpdate, onBalanceUpdate);
        JSEvent.on(Events.Wallet.Ready, onBalanceUpdate);
        updateTotalBalance();
        return () => {
            JSEvent.remove(Events.DataCenter.DATA_UPDATED, onDataUpdate);
            JSEvent.remove(Events.Wallet.BalanceUpdate, onBalanceUpdate);
            JSEvent.remove(Events.Wallet.Ready, onBalanceUpdate);
        }
    }, [])

    const quoteCoin = DataCenter.getCoin(QuoteCoinID);
    const currency = CurrentCurrency();
    const price = DataCenter.getQuotePrice(QuoteCoinID, currency.name)
    const tp = price.times(totalBalance);

    return < div key={WalletAccount.DeFi} className='flex w-full py-4' onClick={e => {
        //DeFi钱包，直接跳转到钱包页面
        JSEvent.emit(Events.MainMenu.SwitchMenu, { menu: "wallet" });
    }}>
        <div className='font-semibold text-gray-600'>{WAIdToName(WalletAccount.DeFi)}</div>
        <div className='flex flex-1 flex-col justify-center items-end'>
            {
                totalBalance == "--" ? (WalletService.ready ? <div className='text-link'>{Localize.getMsg(Localize.COMMON.Create)}</div> : totalBalance) :
                    <>
                        <div className='font-semibold'>
                            {totalBalance.toTrimed(2, quoteCoin.showDecimals) + " " + quoteCoin.name}
                        </div>
                        <div className='text-sm text-gray-600'>≈{currency.symbol}{tp.toCurrencyFixed(currency.decimals)}</div>
                    </>
            }
        </div>
    </div >
}

function WalletPanel(props) {
    let { currAccount, totalBalance, quoteCoin, coinPanels, onTabItemChanged, onButtonClicked, move } = props;

    const [tabSelect, setTabSelect] = useState(WalletAccount.All);
    const [ref, { width }] = useMeasure();
    const styles = useSpring({

        //to: { x: move * width }
    })

    let dom = null;
    if (currAccount == WalletAccount.All) {
        const currency = CurrentCurrency();
        const quoteCoin = DataCenter.getCoin(QuoteCoinID);
        const makeAccountPanel = (name, quoteCount, price, walletAccount) => {
            return <div key={walletAccount} className='flex w-full py-4' onClick={e => {
                let wt = null;
                if (walletAccount == WalletAccount.GameAccount) {
                    wt = WalletTypes[2];
                } else if (walletAccount == WalletAccount.TradeAccount) {
                    wt = WalletTypes[1];
                }
                if (wt != null) {
                    setTabSelect(wt.walletId);
                    onTabItemChanged(wt.type, wt);
                }
            }}>
                <div className='font-semibold text-gray-600'>{name}</div>
                <div className='flex flex-1 flex-col justify-center items-end'>
                    <div className='font-semibold'>{quoteCount.toTrimed(2, quoteCoin.showDecimals) + " " + quoteCoin.name}</div>
                    <div className='text-sm text-gray-600'>≈{currency.symbol}{price.toCurrencyFixed(currency.decimals)}</div>
                </div>
                <div className='flex items-center pl-2 text-gray-400'><ChevronRightIcon className='w-5 h-5' /></div>
            </div>
        }

        let accountPanels = [];

        if (DataCenter.hasSymbolData() && DataCenter.hasWalletData()) {
            const price = DataCenter.getQuotePrice(QuoteCoinID, currency.name);

            const accs = [WalletAccount.TradeAccount, WalletAccount.GameAccount, WalletAccount.DeFi];
            accs.forEach(wa => {
                if (wa == WalletAccount.DeFi) {
                    accountPanels.push(<div className='flex' key={wa}>
                        <WalletPanel_DeFiPanel />
                        <div className='flex items-center pl-2 text-gray-400'><ChevronRightIcon className='w-5 h-5' /></div>
                    </div>)
                } else {
                    const wtb = Calculator.calcTotalBalance(wa);
                    const wprice = wtb.times(price);
                    accountPanels.push(makeAccountPanel(WAIdToName(wa), wtb, wprice, wa));
                }
            })
        } else {
            accountPanels = <div className='w-full h-full flex justify-center items-center'>
                {LoadingSVG}
            </div>
        }


        dom = <div className='flex flex-col h-full flex-1'>
            <div className='bg-white rounded-t-2xl p-3 flex'>
                <TotalBalanceViewWithDefi balance={totalBalance} quoteCoin={quoteCoin} />
            </div>
            <div className='h-2 w-full'></div>
            <div className='flex-1 w-full bg-white p-3 overflow-y-scroll basis-0' >
                <div className="">
                    {accountPanels}
                </div>
            </div>
        </div>
    } else {
        dom = <div className='flex flex-col h-full flex-1'>
            <div className='bg-white rounded-t-2xl p-3'>
                <TotalBalanceView balance={totalBalance} quoteCoin={quoteCoin} />
                <div className='flex mt-5 justify-end'>
                    <Button disabled={WalletService.walletInfo == null} name="L:COMMON.Topup" widthStyle="w-full" type="primary" className="mr-2 text-sm font-semibold" onClicked={e => { onButtonClicked("topup") }} />
                    <Button name="L:COMMON.Withdraw" widthStyle="w-full" type="primary" className="mr-2 text-sm font-semibold" onClicked={e => { onButtonClicked("Withdraw") }} />
                    <Button name="L:COMMON.Transfer" widthStyle="w-full" type="primary" className=" text-sm font-semibold" onClicked={e => { onButtonClicked("Transfer") }} />
                </div>

                {
                    WalletService.walletInfo == null ?
                        <InformationBar text={Localize.getMsg(Localize.UI.FundView.topup_tip)}
                            onClick={e => JSEvent.emit(Events.MainMenu.SwitchMenu, { menu: "wallet" })} />
                        : null
                }
            </div>
            <div className='h-2 w-full'></div>
            <div className='flex-1 w-full bg-white p-3 overflow-y-scroll basis-0' >
                <div className="">
                    {coinPanels}
                </div>
            </div>
        </div>
    }
    return <animated.div ref={ref} className={'w-full flex flex-col flex-1'} style={move ? { ...styles } : {}}>
        <TabMenu2 tabItems={WalletTypes}
            currSelTab={tabSelect}
            isSelectedItem={(currSel, item) => {
                return item.walletId == currSel
            }}
            onItemChanged={(type, item) => {
                setTabSelect(item.walletId);
                onTabItemChanged(type, item)
            }} />
        {dom}
    </animated.div>
}

function TransferPanel({ move, currentAccount, onBackButtonClicked, onHidden, onShown, onTransferButtonClicked }) {
    //let { move, currentAccount, onBackButtonClicked, onHidden, onShown } = props;
    //let [currFromAcc, setCurrFromAcc] = useState(currentAccount);

    const waFromId = WalletAccount.GameAccount;
    const waToId = WalletAccount.TradeAccount;

    const [waFrom, setWAFrom] = useState(waFromId);
    const [waTo, setWATo] = useState(waToId);
    const [currCoin, setCurrCoin] = useState(1);
    const [currAmt, setCurrAmt] = useState(new BigNumber(0));
    const [ref, { width }] = useMeasure();
    const input = useRef();

    useEffect(
        () => {
            if (currentAccount != null) {
                let t = WalletAccount.TradeAccount;
                const f = currentAccount.walletId == WalletAccount.All ? WalletAccount.GameAccount : currentAccount.walletId;
                if (f == WalletAccount.TradeAccount) {
                    t = WalletAccount.GameAccount;
                }
                setWAFrom(f);
                setWATo(t);
                setCurrAmt(new BigNumber(0));
                input.current.value = "";
            }
        }, [currentAccount]
    )

    // if (currentAccount != null) {
    //     waFromId = currentAccount.walletId;
    //     if (waFromId == WalletAccount.TradeAccount) {
    //         waToId = WalletAccount.GameAccount;
    //     }
    // }


    let cc = DataCenter.getCoin(currCoin);
    if (cc == null) cc = { name: "" }

    const balance = DataCenter.walletBalance(waFrom, currCoin, false);
    const frozen = DataCenter.walletFrozen(waFrom, currCoin, false);

    const showNEB = balance == 0;
    const btnTransferEnable = (currAmt != 0) && (currAmt.comparedTo(balance) <= 0);



    const styles = useSpring({
        to: { x: move * width },
        onRest: {
            x: () => {
                if (move == 1 && onHidden != null) {
                    onHidden();
                } else if (move == -1 && onShown != null) {
                    onShown();
                }
            }
        }
    })

    const doTransfer = () => {
        let params = {
            accountId: DataCenter.accountId,
            from: waFrom,
            to: waTo,
            type: currCoin,
            value: currAmt.toFixed()
        };
        onTransferButtonClicked(params);

    }

    return <div className={"w-screen flex flex-1 flex-col bg-white"} >
        <animated.div ref={ref} className={"w-screen flex flex-1 flex-col bg-white"}
            style={move ? { ...styles } : {}} >
            <div className={"w-screen flex flex-1 flex-col  p-4"}>
                <div className=' w-12 h-8 flex flex-col items-start justify-center' onClick={e => { onBackButtonClicked() }}>
                    <ArrowNarrowLeftIcon className="h-6 text-gray-500"
                        aria-hidden="true" /></div>
                <div className=' text-2xl font-medium mt-2'>
                    划转
                </div>
                <InformationBar text={"本次划转不会产生网络费用"} />
                <TransferAccountPanel
                    waFrom={waFrom}
                    waTo={waTo}
                    onExchangeClicked={() => {
                        setWAFrom(waFrom == WalletAccount.GameAccount ? WalletAccount.TradeAccount : WalletAccount.GameAccount);
                        setWATo(waTo == WalletAccount.GameAccount ? WalletAccount.TradeAccount : WalletAccount.GameAccount);
                    }}
                />
                <div className='bg-gray-100 w-full mt-1 mb-1 rounded-lg pl-5 pr-5 pt-2 pb-2 flex flex-col'>
                    <CoinSelector onCoinSelected={coin => { setCurrCoin(coin) }} />
                </div>
                <div className='text-m text-red-500' hidden={!showNEB}>当前币种无可划转资产，请选择其他币种</div>

                <div className='text-xl text-gray-500 mt-5'>数量</div>

                <div className='bg-gray-100 w-full mt-2 mb-1 rounded-lg pl-5 pr-5 pt-2 pb-2 flex flex-row items-center'>
                    <input ref={input} type="number" className=' bg-gray-100 mt-2 mb-2 flex-1 outline-none' onChange={
                        e => {
                            console.log(e.target.value)
                            const v = e.target.value == "" ? "0" : e.target.value;
                            setCurrAmt(new BigNumber(v));
                        }
                    } />
                    <div className='text-gray-400'>{cc.name.toUpperCase()}</div>
                    <div className='text-txt-selected pl-3 pr-3' onClick={() => {
                        input.current.value = balance.toFixed();
                        setCurrAmt(balance);
                    }}>最大</div>
                </div>
                <div className='text-m text-red-500' hidden={currAmt.comparedTo(balance) <= 0}>可用资产数量不足</div>
                <div className='w-full flex flex-row'>
                    <div className='text-gray-400'>可用资产：</div>
                    <div className='flex-1 items-end justify-end flex'>{balance.toFixed(cc.showDecimals)} {cc.name.toUpperCase()}</div>
                </div>
                {
                    waFrom == WalletAccount.TradeAccount ?
                        <div className='w-full flex flex-row pt-1'>
                            <div className='text-gray-400'>下单冻结：</div>
                            <div className='flex-1 items-end justify-end flex'>{frozen.toFixed(cc.showDecimals)} {cc.name.toUpperCase()}</div>
                        </div> : <div></div>
                }
            </div>
        </animated.div>
        <BottomButtons
            move={move}
            btnTransferEnable={btnTransferEnable}
            onClick={btn => {
                if (btn == "transfer") {
                    doTransfer();
                } else if (btn == "back") {
                    onBackButtonClicked();
                }
            }}
        />
    </div>
}

function BottomButtons({ move, btnTransferEnable, onClick }) {
    const h = move == -1 ? 64 : 0;
    const styles = useSpring({
        to: { height: h },
    })
    return <animated.div className=' absolute overflow-hidden px-3 w-full flex flex-col left-0 bottom-0 h-[0px] bg-gray-100' style={{ ...styles }}>
        <div className='flex flex-row pt-2'>
            <Button className="text-xl font-semibold h-12" rounded="rounded-l-md"
                widthStyle="flex-1" name="确认划转" type="primary" disabled={!btnTransferEnable} onClicked={e => {
                    onClick("transfer");
                }} />
            <Button name="返回" rounded="rounded-r-md" onClicked={e => {
                onClick("back");
            }} />
        </div>
    </animated.div>
}


class TransferAccountPanel extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { waFrom, waTo, onExchangeClicked } = this.props;
        return (
            <div className='bg-gray-100 w-full mt-3 mb-5 rounded-lg p-5 flex flex-row'>
                <div className='pl-5 flex-1 flex flex-col'>
                    <div className='flex'>
                        <div className='text-gray-500'>从</div>
                        <div className='ml-10 text-lg'>
                            {WAIdToName(waFrom)}
                        </div>
                    </div>
                    <div>
                        <ArrowNarrowDownIcon className="mt-2 mb-2 h-4 text-gray-400"
                            aria-hidden="true" />
                    </div>
                    <div className='flex'>
                        <div className='text-gray-500'>到</div>
                        <div className='ml-10 text-lg'>
                            {WAIdToName(waTo)}
                        </div>
                    </div>
                </div>
                <div className='w-8 mr-3 flex flex-row items-center' onClick={e => {
                    onExchangeClicked();
                }}>
                    <img src={iconExchange} />
                </div>
            </div>
        );
    }
}

/**
 * props:{
 * 
 * { BigNumber } balance
        *      {CoinSpec} quoteCoin
 * }
        */
class TotalBalanceView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const quoteCoin = this.props.quoteCoin;
        const showDecimals = quoteCoin == null ? 0 : quoteCoin.showDecimals;
        const quoteName = quoteCoin == null ? "" : quoteCoin.name;
        const currency = CurrentCurrency();
        let prize = 0;
        if (quoteCoin != null) {
            prize = DataCenter.getQuotePrice(quoteCoin.id, currency.name).toNumber();
        }
        return (
            <div className='flex flex-col'>
                <div className='text-gray-500 text-m'>{Localize.getMsg(Localize.COMMON.equityValue)}({quoteName})</div>
                <div className='flex items-center'>
                    <BalanceLabel className='text-3xl'
                        balance={this.props.balance} decimals={showDecimals} />
                    <div className='flex pl-1 text-gray-500'>≈
                        <BalanceLabel className='pl-1'
                            balance={this.props.balance} decimals={currency.decimals} show={1}
                            exchangeRate={prize} coinSymbol={currency.symbol} />
                    </div>
                </div>
            </div>
        );
    }
}
